/**
 * CMCD header fields.
 *
 * @group CMCD
 *
 * @beta
 */
export var CmcdHeaderField;
(function (CmcdHeaderField) {
    /**
     * keys whose values vary with the object being requested.
     */
    CmcdHeaderField["OBJECT"] = "CMCD-Object";
    /**
     * keys whose values vary with each request.
     */
    CmcdHeaderField["REQUEST"] = "CMCD-Request";
    /**
     * keys whose values are expected to be invariant over the life of the session.
     */
    CmcdHeaderField["SESSION"] = "CMCD-Session";
    /**
     * keys whose values do not vary with every request or object.
     */
    CmcdHeaderField["STATUS"] = "CMCD-Status";
})(CmcdHeaderField || (CmcdHeaderField = {}));
//# sourceMappingURL=CmcdHeaderField.js.map